import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const AppComponent = React.createElement(App);
const root = createRoot(document.getElementById('root')!);
root.render(<App />);
